const ScrollTrack = ({ style, nodeRef, children, className, width }) => (
  <div style={{ ...style, width }} ref={nodeRef} className={className}>
    {children}
  </div>
);

ScrollTrack.defaultProps = {
  className: 'track-vertical',
  style: {
    position: 'absolute',
    height: '100%',
    right: 0,
  },
};

export default ScrollTrack;
